/**
 * SINGLE SOURCE OF TRUTH for schedule column headers.
 * Every validator path (Make Remittances worker + Schedule Validator tool)
 * must derive its keys/labels from here so they can never drift apart.
 */

export const scheduleHeaders = {
  employerCode: "EMPLOYER CODE",
  month: "For The Month Of",
  year: "Year Of Contribution",
  staffId: "Staff ID",
  rsapin: "RSA PIN",
  employeeName: "Name of Employee",
  normalContributionEmployee: "Normal contribution for employee",
  normalContributionEmployer: "Normal contribution for employer",
  voluntaryContributionEmployee: "Voluntary contribution by employee",
  voluntaryContributionEmployer: "Voluntary contribution by employer",
  otherContribution: "Other Contribution",
  contributionType: "Contribution Type/Code",
  total: "TOTAL AMT.(Naira)",
  pfaCode: "PFA code",
} as const;

export type ScheduleHeader = typeof scheduleHeaders[keyof typeof scheduleHeaders];

export const allHeaders: ScheduleHeader[] = Object.values(scheduleHeaders);

/**
 * Lookup: lowercase-trimmed header text -> canonical header.
 */
export const canonicalHeaderLookup: Map<string, string> = new Map(
  allHeaders.map(h => [h.trim().toLowerCase(), h])
);
